import React, { useEffect } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
    StyledCard,
    StyledCardContent,
    Text,
    OutlinedButton,
    InputWithEndAdornment,
    SearchIcon,
    FormGroup,
    NoInformation,
    Progress,
    ProviderButton,
} from '../../index.js';

import { StyledDialog, StyledPaper } from './style';

const SelectStaffDialog = ({
    open,
    onClose,
    selectedStaff,
    searchValue,
    setSearchValue,
    onSelect,
    providerListData,
    user,
    loading,
}) => {
    useEffect(() => {
        if (open && !_.isEmpty(selectedStaff)) {
            onSelect(selectedStaff);
        }
    }, [open, selectedStaff]);

    const handleSelect = (value) => {
        onSelect(value);
        onClose();
        setSearchValue('');
    };

    return (
        <StyledDialog
            scroll="body"
            open={open}
            onClose={onClose}
            aria-labelledby="SelectStaffDialog"
            aria-describedby="Select Staff to appointment"
            PaperComponent={StyledPaper}
        >
            <StyledCard padding="20px">
                <StyledCardContent
                    style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}
                >
                    <div>
                        <Text $fontSize="20px" $bold>
                            Add Provider
                        </Text>
                    </div>
                    <div style={{ position: 'relative' }}>
                        {loading && <Progress />}
                        <InputWithEndAdornment
                            id="search"
                            name="search"
                            placeholder="Search"
                            startAdornment={
                                <InputAdornment
                                    position="start"
                                    style={{ opacity: 0.6, marginLeft: '10px' }}
                                >
                                    <SearchIcon fill="gray2" />
                                </InputAdornment>
                            }
                            type="text"
                            style={{ height: '32px' }}
                            inputPropsStyle={{ paddingLeft: '15px' }}
                            onChange={(e) => setSearchValue(e.target.value)}
                            value={searchValue}
                            autoComplete="off"
                            inputProps={{ maxLength: 100 }}
                        />
                        <div style={{ height: '500px' }}>
                            <FormGroup
                                row
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    rowGap: '10px',
                                    maxHeight: '500px',
                                    overflowX: 'auto',
                                    paddingBottom: '10px',
                                }}
                            >
                                {!_.isEmpty(providerListData) ? (
                                    providerListData.map((item) => (
                                        <ProviderButton
                                            key={item.value}
                                            data={item}
                                            onClick={() => handleSelect(item.value)}
                                            user={user}
                                            $avatarSize="46px"
                                            buttonStyle={{ height: '60px' }}
                                            containerStyle={{ padding: '7px 15px' }}
                                        />
                                    ))
                                ) : (
                                    <NoInformation height="200px" />
                                )}
                            </FormGroup>
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            columnGap: '10px',
                        }}
                    >
                        <OutlinedButton style={{ height: '32px', width: '80px' }} onClick={onClose}>
                            Cancel
                        </OutlinedButton>
                    </div>
                </StyledCardContent>
            </StyledCard>
        </StyledDialog>
    );
};

SelectStaffDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    selectedStaff: PropTypes.string,
    onCancel: PropTypes.func,
    onSelect: PropTypes.func,
    searchValue: PropTypes.string,
    setSearchValue: PropTypes.func,
    providerListData: PropTypes.arrayOf(PropTypes.object),
    user: PropTypes.object,
    loading: PropTypes.bool,
};

export default SelectStaffDialog;
